import { createContext, useContext } from "react";

/**
 * SidebarContext - Prevents duplicate MainSidebar rendering
 *
 * When MainSidebar is rendered at a higher level (like PrivateRoute),
 * this context tells AuthorizedLayout to skip rendering its own copy.
 *
 * Note: TopBar is always rendered by PrivateRoute for partner users.
 */
export const SidebarContext = createContext({
  sidebarRenderedByParent: false,
});

export const useSidebarContext = () => useContext(SidebarContext);
